import React, { Fragment } from 'react';
import MultiCarouselProduct from './MultiCarouselProduct';

const sameCategory = (item, index, array) => index > 0 && array[index - 1].category === array[index].category || item.showAll;
let r = Math.random().toString(36).substring(7);

const QuickSearchResult = ({ result, selectedItem, searchUrl }) => (
    <div className="quick-search-result">
        <div className="quick-search-result__container">
            <div className="quick-search-result__links-wrapper">
                <ul className="quick-search-result__links-container">
                    {result && result.filter(item => item.category !== "Products" && item.category !== "ShowAll").map((item, index, array) => (
                        <Fragment key={`${item.name}-${index}-${r}`}>
                            {item.category === 'NoHit' || sameCategory(item, index, array) ? null :
                                <li className="quick-search-result__item quick-search-result__group-header"><h4 className="as-h3">{item.category}</h4></li>
                            }
                            <li className={`quick-search-result__item ${selectedItem === index ? 'quick-search-result__item--selected' : ''}`} >
                                <a className={item.showAll ? 'quick-search-result__show-all' : `quick-search-result__link ${item.url ? '' : 'quick-search-result__link--disabled'}`}
                                    href={item.showAll ? searchUrl : item.url}>                                        
                                    {item.hasImage && item?.imageSource?.key && <img className="quick-search-result__image" src={item.imageSource.key} 
                                    alt={item.imageSource.value}/>}
                                    <div className="quick-search-result__result-name">{item.name}</div>
                                </a>
                            </li>

                        </Fragment>
                    ))}
                </ul>
            </div>
            <div className="quick-search-result__products-wrapper">
                <ul className="quick-search-result__products-container">
                    {result && result.filter(item => item.category === "Products").map((item, index, array) => (
                        <Fragment key={`product-${item.name}-${index}-${r}`}>
                            <li className="quick-search-result__product-item">
                                <MultiCarouselProduct item={item} index={index}></MultiCarouselProduct>
                            </li>
                        </Fragment>
                    ))}
                </ul>
                {result && result.filter(item => item.category === "ShowAll").map((item) => (
                    <div key={`seeall-${item.name}-${r}`} className="quick-search-result__show-all-container">
                        <a className="quick-search-result__show-all" href={searchUrl} key={`show-all-${item.name}-${r}`}>
                            <h3 className="small quick-search-result__show-all-header">{item.name}</h3>
                        </a>
                    </div>
                ))}
            </div>
        </div>
    </div>
);

export default QuickSearchResult;
